import Vue from 'vue'
import Vuex from 'vuex'
import { _cfg } from '@/config'
import _isEmpty from 'lodash.isempty'
import moduleSecurity from './security'
import moduleWizard from './wizard'
import moduleUser from './user'

Vue.use(Vuex)

export default new Vuex.Store({

  // ----------------------------------------------------------------- [Modules]

  modules: {
    moduleSecurity,
    moduleWizard,
    moduleUser
  },

  // ------------------------------------------------------------------- [State]

  state: {
    // Default app config
    config: {
      token: '',
      branded: '' // brand name
    }
  },

  // ----------------------------------------------------------------- [Getters]

  getters: {
    /**
     * Get branded class
     */
    getBrandedClass (state) {
      if (_isEmpty(state.config.branded)) return false
      return { [`branded-${state.config.branded}`]: true }
    }
  },

  // --------------------------------------------------------------- [Mutations]

  mutations: {

    /**
     * Set app config
     * @description Sets parent location params to state
     * @param {Object} state - Security SM state
     * @param {Object} location - Given location obj
     */
    SET_APP_CONFIG (state, config) {
      for (const key in state.config) {
        if (!(key in config)) continue // there is no such option in config
        if (_isEmpty(config[key])) continue // if empty content
        switch (key) {
          case 'branded':
            if (_cfg.security.brands.indexOf(config[key]) === -1) continue
            state.config[key] = config[key]
            break
          default:
            state.config[key] = config[key]
        }
      }
    }
  },

  // ----------------------------------------------------------------- [Actions]

  actions: {

    /**
     * Get app current height
     * @description Returns application current height value
     * @returns {Number}
     */
    getAppCurrentHeight () {
      const body = document.body
      const html = document.documentElement
      return Math.max(
        body.scrollHeight,
        body.offsetHeight,
        html.clientHeight,
        html.scrollHeight,
        html.offsetHeight
      )
    }

  }

})
